module.exports = __webpack_public_path__ + "6760adecacec5520971a932a0a6498b0.mp3";